import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown19 } from "@fortawesome/pro-regular-svg-icons";

import $store, { spaceNumbersSelector, SpaceType } from "../../../../../store";

import { TextMarkerDecoration } from "./TextMarkerDecoration";

export class SpaceNumberMarkerDecoration extends TextMarkerDecoration {
  spaceNumber(space: SpaceType) {
    return spaceNumbersSelector($store.getState())[space.id];
  }

  textContent(space?: SpaceType): string {
    if (!space) return '__SPACE_NUMBER__';
    return this.spaceNumber(space);
  }

  // We don't know the content length when serializing,
  // as it depends on the space, so return a fixed length
  textContentLength(_space?: SpaceType) {
    return 1;
  }

  Thumbnail() {
    return (
      <FontAwesomeIcon icon={faArrowDown19} />
    );
  }

  title = 'Space Number';
}
